import styled from "styled-components";
import { Row } from "react-bootstrap";

export const HeaderRow = styled(Row)`
  margin-bottom: 20px;
`;
